<li *ngIf="!opt.disabled" [class]="opt.class[0]">
    <a [routerLink]="opt.url" href="javascript:void(0);" [attr.aria-label]="opt.label" [title]="opt.label">
        {{opt.label}}
    </a>
</li>

<li *ngIf="opt.disabled" [class]='opt.class[1]'>
  <span>{{opt.label}}</span>
</li>
